import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function PendingSale (){
  const {user} = useUser()
  let view = contentLayout[modules.PendingSalesList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.PendingSalesList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.PendingSalesList}></Index>
 )
}

export default PendingSale